import React from 'react';
import styles from '@/assets/styles/Profile.module.less';
import UserInfo, { useUserInfo } from '../common/UserInfo';

const MyInfoContent: React.FC = () => {
  const userInfo = useUserInfo();

  const infoItems = [
    { label: '账号ID', value: userInfo.userId },
    { label: '昵称', value: userInfo.name },
    { label: '邮箱', value: userInfo.email },
    { label: '电话', value: userInfo.phoneNumber },
    { label: '简介', value: userInfo.bio },
  ];

  const InfoItem = ({ label, value }: { label: string; value: string | undefined }) => (
    <div className={styles.infoItem}>
      <span className={styles.label}>{label}：</span>
      <span className={styles.value}>{value || '-'}</span>
    </div>
  );

  return (
    <div className={styles.myInfoContainer}>
      <h2 className={styles.sectionTitle}>我的资料</h2>
        <div className={styles.infoGrid}>
          {infoItems.map((item) => (
            <InfoItem key={item.label} label={item.label} value={item.value} />
          ))}
        </div>
    </div>
  );
};

const MyInfo: React.FC = () => {
  return (
    <UserInfo title="我的资料">
      <MyInfoContent />
    </UserInfo>
  );
};

export default MyInfo;
